'use strict';


'kiwi public';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _TextFormatting = require('@/helpers/TextFormatting');

var TextFormatting = _interopRequireWildcard(_TextFormatting);

var _state = require('@/libs/state');

var _state2 = _interopRequireDefault(_state);

var _AwayStatusIndicator = require('./AwayStatusIndicator');

var _AwayStatusIndicator2 = _interopRequireDefault(_AwayStatusIndicator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {
    components: {
        AwayStatusIndicator: _AwayStatusIndicator2.default
    },
    props: ['network'],
    data: function data() {
        return {
            is_usermenu_open: false
        };
    },

    computed: {
        userInitial: function userInitial() {
            var initial = 'U';
            if (this.network && this.network.nick) {
                initial = this.network.nick.charAt(0).toUpperCase();
            }
            return initial;
        },
        networkName: function networkName() {
            var name = TextFormatting.t('no_network');
            if (this.network) {
                name = this.network.name;
            }
            return name;
        },
        getUser: function getUser() {
            return this.network ? this.network.currentUser() : null;
        },
        isConnected: function isConnected() {
            return this.network && this.network.state === 'connected';
        }
    },
    methods: {
        clickForget: function clickForget() {
            var msg = 'This will delete all stored networks and start fresh. Are you sure?';

            var confirmed = confirm(msg);
            if (!confirmed) {
                return;
            }

            _state2.default.persistence.forgetState();
            window.location.reload();
        }
    }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["StateBrowserUsermenu"]
window._kiwi_exports.components.StateBrowserUsermenu = exports.default ? exports.default : exports;



//////////////////
// WEBPACK FOOTER
// ./build/exports-loader.js!./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/StateBrowserUsermenu.vue
// module id = bd+S
// module chunks = 1